(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v4-aegis-product-main"]) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.v4-product--aegis[data-product-root]');
    roots.forEach((root) => {
      if (root.dataset.aegisGalleryBound === '1') return;
      root.dataset.aegisGalleryBound = '1';
      const panels = [...root.querySelectorAll('[data-product-gallery-panel]')];
      const triggers = [...root.querySelectorAll('[data-product-gallery-trigger]')];
      triggers.forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-product-gallery-trigger');
          triggers.forEach((b) => {
            const on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          panels.forEach((p) => {
            const on = p.getAttribute('data-product-gallery-panel') === id;
            p.classList.toggle('is-active', on);
            if (on) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
